import React from 'react'
import Button from '../../atoms/Button/Button'
import { ArrowRight } from '../../atoms/NewIcons'
import Link from 'next/link'
import MyImage from '../../atoms/MyImage/MyImage'
import useTrans from '../../../hooks/useTrans'
import { getAltText } from '../../../utils/safe'

const CatalogoBrandHome = ({ img, brand_image, title, url }) => {
  const t = useTrans()
  return (
    <Link legacyBehavior href={url ? url : ''}>
      <a className="catalogo-brand-home">
        <div className="catalogo-brand-home__container">
          {img?.url && (
            <MyImage
              className="catalogo-brand-home__image"
              src={img.url}
              alt={getAltText(img) || title}
              title={title}
              layout={'fill'}
              objectFit={'cover'}
              priority={false}
              loading="lazy"
            />
          )}
        </div>
        <div className="catalogo-brand-home__content">
          {brand_image?.url && (
            <MyImage
              className="catalogo-brand-home__image"
              src={brand_image.url}
              alt={getAltText(brand_image) || title}
              title={title}
              layout="intrinsic"
              width={140}
              height={48}
              objectFit="contain"
              priority={false}
              loading="lazy"
            />
          )}
          <Button
            className="catalogo-brand-home__cta"
            size="large"
            responsive={true}
            variant="secondary"
            colorVariant="blue"
            icon={<ArrowRight />}
            ariaLabel={t('vai al catalogo brand {0}', [title])}
          />
        </div>
      </a>
    </Link>
  )
}

export default CatalogoBrandHome
